import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNaN from 'lodash/isNaN';
import _trim from 'lodash/trim';
import _toNumber from 'lodash/toNumber';
import _isNumber from 'lodash/isNumber';
import _identity from 'lodash/identity';
import _isInteger from 'lodash/isInteger';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _some from 'lodash/some';
import _compact from 'lodash/compact';
import _size from 'lodash/size';
import _head from 'lodash/head';
import _dropRight from 'lodash/dropRight';
import _curry from 'lodash/curry';
import _split from 'lodash/split';
import { validateEmail } from '../services/emailService';
import getDataFromResponse from './getDataFromResponse';
import { isEmptyRow } from '../helpers/tableRowHelper';
import { EMPTY_STRING, EMPTY_ARRAY, EMPTY_OBJECT } from '../app.constants';
import * as DateUtils from './dateUtils';
import { getPhoneNo } from './phoneNumberInputUtils';
import CONSTANTS from './constant';
export var isPhoneValid = {
  isValid: false,
  message: __('Enter Valid Number')
};
export var isEmailRule = function isEmailRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === '') return {
    isValid: true
  };
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line

  var isValid = re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Please enter valid email address')
  };
};
export var asyncEmailRule = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fieldId, valueToTest) {
    var _isEmailRule, isValid, message, response, sanitizedResponse;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!valueToTest) {
              _context.next = 17;
              break;
            }

            // Until email is valid(validated by UI regex) we are not making api call to check valid/fake email
            _isEmailRule = isEmailRule(fieldId, valueToTest), isValid = _isEmailRule.isValid, message = _isEmailRule.message;

            if (isValid) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", {
              isValid: isValid,
              message: message
            });

          case 4:
            _context.prev = 4;
            _context.next = 7;
            return validateEmail(valueToTest);

          case 7:
            response = _context.sent;
            sanitizedResponse = getDataFromResponse(response);

            if (_get(sanitizedResponse, 'validationStatus.isValid')) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", {
              isValid: false,
              message: __('Please enter valid email address')
            });

          case 11:
            return _context.abrupt("return", {
              isValid: true
            });

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](4);
            return _context.abrupt("return", {
              isValid: true
            });

          case 17:
            return _context.abrupt("return", {
              isValid: true
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 14]]);
  }));

  return function asyncEmailRule(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var isRequiredRule = function isRequiredRule(fieldId, valueToTest) {
  var isValid = '';

  if (valueToTest && valueToTest.constructor === Array) {
    isValid = !_isEmpty(valueToTest);
  } else isValid = !(_trim(valueToTest) === '' || _isNil(valueToTest));

  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('This field is mandatory')
  };
};
export var isNumericRule = function isNumericRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === '') return {
    isValid: true
  };

  try {
    var isValid = !Number.isNaN(parseFloat(+valueToTest));
    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Enter Valid Data')
    };
  } catch (err) {
    return {
      isValid: false,
      message: __('Enter Valid Data')
    };
  }
};
export var isIntegerRule = function isIntegerRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === '') return {
    isValid: true
  };

  try {
    var isValid = _isInteger(valueToTest);

    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Enter Valid Number')
    };
  } catch (err) {
    return {
      isValid: false,
      message: __('Enter Valid Number')
    };
  }
};
export var isNumber = function isNumber(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === '') return {
    isValid: true
  }; // TEMP: looking for a better solution

  try {
    var isValid = CONSTANTS.GENERAL.REG_EXPR.ONLY_DIGITS.test(valueToTest);
    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Enter Valid Number')
    };
  } catch (err) {
    return isPhoneValid;
  }
};
export var nonNegativeRule = function nonNegativeRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === EMPTY_STRING) return {
    isValid: true
  };
  var valueInFloat = parseFloat(valueToTest);
  if (_isNil(valueInFloat) || _isNaN(valueInFloat)) return {
    isValid: false,
    message: __('Enter valid number')
  };
  if (valueInFloat < 0) return {
    isValid: false,
    message: __('Value cannot be negative')
  };
  return {
    isValid: true
  };
};
export var nonZeroRule = function nonZeroRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === EMPTY_STRING) return {
    isValid: true
  };
  if (parseFloat(valueToTest, 10) === 0) return {
    isValid: false,
    message: __('Value cannot be 0')
  };
  return {
    isValid: true
  };
};
export var isPhoneNumberRule = function isPhoneNumberRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || valueToTest === '') return {
    isValid: true
  };

  if (/^\d+$/.test(valueToTest)) {
    if (valueToTest.length !== 10) return {
      isValid: false,
      message: __('Enter a valid 10 digit phone number')
    };
    return {
      isValid: true
    };
  }

  return {
    isValid: false,
    message: __('Enter a valid 10 digit phone number')
  };
};
export var socialSecurityRule = function socialSecurityRule(fieldId, valueToTest) {
  if (!valueToTest) return {
    isValid: true
  };

  if (valueToTest.length === 9 && isNumber(valueToTest)) {
    return {
      isValid: true
    };
  }

  return {
    isValid: false,
    message: __('Enter a valid 9 digit Social Security Number')
  };
};
export var isLessThanRule = function isLessThanRule(value) {
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity;
  var customMessage = arguments.length > 2 ? arguments[2] : undefined;
  return function (fieldId, valueToTest) {
    if (_toNumber(value) >= _toNumber(valueToTest)) return {
      isValid: true
    };
    return {
      isValid: false,
      message: customMessage || __('value should be less than {{ formattedValue }}', {
        formattedValue: formatter(value)
      })
    };
  };
};
export var isGreaterThanRule = function isGreaterThanRule(value) {
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity;
  var customMessage = arguments.length > 2 ? arguments[2] : undefined;
  return function (fieldId, valueToTest) {
    if (_isNil(valueToTest) || valueToTest === EMPTY_STRING) return {
      isValid: true
    };
    if (_toNumber(value) < _toNumber(valueToTest)) return {
      isValid: true
    };
    return {
      isValid: false,
      message: customMessage || __('value should be greater than {{ formattedValue }}', {
        formattedValue: formatter(value)
      })
    };
  };
};
export var shouldBeGreaterThan = function shouldBeGreaterThan(smallerValue, errorMessage) {
  return function (fieldId, value) {
    if (_isNumber(smallerValue) && Number(value) < Number(smallerValue)) {
      return {
        isValid: false,
        message: errorMessage
      };
    }

    return {
      isValid: true
    };
  };
};
export var shouldBeSmallerThan = function shouldBeSmallerThan(greaterValue, errorMessage) {
  return function (fieldId, value) {
    if (_isNumber(greaterValue) && Number(value) > Number(greaterValue)) {
      return {
        isValid: false,
        message: errorMessage
      };
    }

    return {
      isValid: true
    };
  };
};
export var vinValidationRule = function vinValidationRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || _isEmpty(valueToTest)) return {
    isValid: true
  };

  if (valueToTest.length !== 17) {
    return {
      isValid: false,
      message: __('Enter a valid 17 digit VIN')
    };
  }

  return {
    isValid: true
  };
};
export var isFloatingRule = function isFloatingRule(fieldId, valueToTest) {
  if (_isNil(valueToTest)) return {
    isValid: true
  };

  try {
    var isValid = CONSTANTS.GENERAL.REG_EXPR.POSITIVE_FLOAT.test(valueToTest);
    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Enter Valid Number')
    };
  } catch (err) {
    return isPhoneValid;
  }
};
export var noDuplicateValue = function noDuplicateValue(availableList, edit, message) {
  return function (fieldId, value) {
    if (!value) {
      return {};
    }

    if (!edit && availableList.includes(value)) {
      return {
        isValid: false,
        message: message
      };
    }

    return {
      isValid: true
    };
  };
};
export var isAlphaNumericRule = function isAlphaNumericRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var alphaNumeric = /^[0-9a-zA-Z]+$/;
  if (valueToTest.match(alphaNumeric)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Only alpha-numeric allowed')
  };
};
export var hasNumberRule = function hasNumberRule(fieldId, valueToTest) {
  var re = /\d/;
  var isValid = re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Should contain atleast one number')
  };
};
export var minimumLengthRule = function minimumLengthRule(fieldId, valueToTest, minimumLength) {
  var valueLength = _size(valueToTest);

  var isValid = valueLength >= minimumLength;
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Should contain atleast {{ minimumLength }} characters', {
      minimumLength: minimumLength
    })
  };
};
export var maximumLengthRule = function maximumLengthRule(maximumLength) {
  return function (fieldId, valueToTest) {
    var valueLength = _size(valueToTest);

    var isValid = valueLength <= maximumLength;
    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Should not contain more than {{ maximumLength }} characters', {
        maximumLength: maximumLength
      })
    };
  };
};
export var hasLowerCaseChar = function hasLowerCaseChar(fieldId, valueToTest) {
  var re = /^(?=.*[a-z])/;
  var isValid = re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Should contain atleast one uppercase character')
  };
};
export var hasUpperCaseChar = function hasUpperCaseChar(fieldId, valueToTest) {
  var re = /^(?=.*[A-Z])/;
  var isValid = re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Should contain atleast one lowercase character')
  };
};
export var onlySpecialCharacters = function onlySpecialCharacters(fieldId, valueToTest) {
  var re = /([><"&\'|@/?:])/; //eslint-disable-line

  var isValid = !re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Contains only special characters')
  };
};
export var isValidPhoneNumber = function isValidPhoneNumber(fieldId, valueToTest) {
  var re = /^[0-9]{3,14}$/; // According to https://en.wikipedia.org/wiki/E.164 international number can be 15 digits long

  var isValid = re.test(valueToTest);
  return isValid ? {
    isValid: isValid
  } : {
    isValid: isValid,
    message: __('Enter a valid mobile number')
  };
};
export var isTableColumnUnique = function isTableColumnUnique(fieldId, valueToTest, _ref2) {
  var _ref2$allValues = _ref2.allValues,
      allValues = _ref2$allValues === void 0 ? EMPTY_OBJECT : _ref2$allValues,
      _ref2$pathToUpdate = _ref2.pathToUpdate,
      pathToUpdate = _ref2$pathToUpdate === void 0 ? 0 : _ref2$pathToUpdate,
      _ref2$tableFieldId = _ref2.tableFieldId,
      tableFieldId = _ref2$tableFieldId === void 0 ? '' : _ref2$tableFieldId;

  var tableValues = _get(allValues, tableFieldId, EMPTY_ARRAY);

  var tableFieldValues = _compact(_map(tableValues, function (item) {
    return _head(_get(item, "".concat(fieldId), ''));
  }));

  return _some(tableFieldValues, function (item, index) {
    return item === _head(valueToTest) && index !== _toNumber(pathToUpdate);
  }) ? {
    isValid: false,
    message: __('Cannot have duplicate values')
  } : {
    isValid: true
  };
};
export var nonEmptyTableValidator = function nonEmptyTableValidator() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __('Should not be empty');
  return function (fieldId, valueToTest, _ref3) {
    var _ref3$allValues = _ref3.allValues,
        allValues = _ref3$allValues === void 0 ? EMPTY_OBJECT : _ref3$allValues,
        _ref3$tableFieldId = _ref3.tableFieldId,
        tableFieldId = _ref3$tableFieldId === void 0 ? '' : _ref3$tableFieldId;

    var tableValues = _get(allValues, tableFieldId, EMPTY_ARRAY);

    var tableValuesWithoutLastRow = _dropRight(tableValues); // removing isLastRow


    if (!valueToTest && _isEmpty(tableValuesWithoutLastRow)) {
      return {
        isValid: false,
        message: errorMessage
      };
    }

    return {
      isValid: true
    };
  };
};
export var getASCIIValidator = function getASCIIValidator() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __('Invalid character entered!');
  return function (fieldId, valueToTest) {
    var asciiRegex = /^[ -~]*$/;
    return asciiRegex.test(valueToTest) ? {
      isValid: true
    } : {
      isValid: false,
      message: errorMessage
    };
  };
};
export var getZipCodeValidator = function getZipCodeValidator() {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __('Invalid Zip Code');
  return function (fieldId, valueToTest) {
    return _isEmpty(valueToTest) || /(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/.test(valueToTest) ? {
      isValid: true
    } : {
      isValid: false,
      message: errorMessage
    };
  };
};
export var noSpecialCharacterRule = function noSpecialCharacterRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var re = /^[0-9a-zA-Z ]+$/;
  if (valueToTest.match(re)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Special characters are not allowed.')
  };
};
export var isAlphabetWithSpaceRule = function isAlphabetWithSpaceRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var alphabets = /^[a-zA-Z ]+$/;
  if (valueToTest.match(alphabets)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Only alphabets allowed')
  };
};
export var isAlphabetWithoutSpaceRule = function isAlphabetWithoutSpaceRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var alphabets = /^[a-zA-Z]+$/;
  if (valueToTest.match(alphabets)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Only alphabets allowed')
  };
};
export var isAlphaNumericWithSpaceRule = function isAlphaNumericWithSpaceRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var alphaNumericWithSpace = /^[0-9a-zA-Z ]+$/;
  if (valueToTest.match(alphaNumericWithSpace)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Only alpha-numeric allowed')
  };
};
export var isAlphaNumericWithoutSpaceRule = function isAlphaNumericWithoutSpaceRule(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var alphaNumericWithSpace = /^[0-9a-zA-Z]+$/;
  if (valueToTest.match(alphaNumericWithSpace)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Only alpha-numeric allowed')
  };
};
export var isRequiredRuleButLastRow = function isRequiredRuleButLastRow(fieldId, valueToTest, _ref4) {
  var pathToUpdate = _ref4.pathToUpdate,
      tableFieldId = _ref4.tableFieldId,
      allValues = _ref4.allValues;

  var isLastRow = _get(allValues, "".concat(tableFieldId, ".").concat(pathToUpdate, ".isLastRow"));

  if (isLastRow) return {
    isValid: isLastRow
  };
  return isRequiredRule(fieldId, valueToTest);
};
/**
 *
 * @param {Moment} dateTime : moment time
 * @returns moment date by calculating the time and combining it with todays data always.
 */

var getMomentWithTime = function getMomentWithTime(dateTime) {
  return DateUtils.toMoment({
    h: DateUtils.toMoment(dateTime).hours(),
    m: DateUtils.toMoment(dateTime).minutes()
  });
};
/**
 * validates isBefore rule for moment fields
 * @param {any} greaterValue can be a momentObject or a timestamp to be compared against
 * @param {any} errorMessage the message to be displayed for validation
 * * @param {any} config the config to be passed for isAfter
 * @returns an object with { isValid, message }
 * @desc takes both dateStamps and only considers time component to update the time while comparision
 * @desc takes both dateStamps and only considers time component for comparision
 */


export var shouldBeBefore = function shouldBeBefore(greaterValue, errorMessage) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    unit: 'minute'
  };
  return function (fieldId, value) {
    if (greaterValue && value) {
      var greaterTimeValue = getMomentWithTime(greaterValue);
      var timeValue = getMomentWithTime(value);

      if (DateUtils.isAfter(greaterTimeValue, timeValue, config)) {
        return {
          isValid: false,
          message: errorMessage
        };
      }
    }

    return {
      isValid: true
    };
  };
};
/**
 * validates isAfter rule for moment fields
 * @param {any} greaterValue can be a momentObject or a timestamp to be compared against
 * @param {any} errorMessage the message to be displayed for validation
 * * @param {any} config the config to be passed for isAfter
 * @returns an object with { isValid, message }
 * @desc takes both dateStamps and only considers time component to update the time while comparision
 * @desc takes both dateStamps and only considers time component for comparision
 */

export var shouldBeAfter = function shouldBeAfter(greaterValue, errorMessage, inclusive) {
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
    unit: 'minute'
  };
  return function (fieldId, value) {
    if (greaterValue && value) {
      var greaterTimeValue = getMomentWithTime(greaterValue);
      var timeValue = getMomentWithTime(value);

      if (inclusive && DateUtils.getDifferenceAsSeconds(timeValue, greaterTimeValue) <= 0 || DateUtils.isBefore(greaterTimeValue, timeValue, config)) {
        return {
          isValid: false,
          message: errorMessage
        };
      }
    }

    return {
      isValid: true
    };
  };
};
export var isValidURLRule = function isValidURLRule(fieldId, valueToTest) {
  // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
  var pattern = new RegExp('^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_\\/]*)?$', 'i');
  var isValid = !valueToTest ? true : pattern.test(valueToTest);
  return _objectSpread({
    isValid: isValid
  }, !isValid ? {
    message: __('Only valid URLs allowed')
  } : EMPTY_OBJECT);
};
export var newIsValidURLRule = function newIsValidURLRule(fieldId, valueToTest) {
  // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;:&a-z\\d%_.~+=-]*)?' + // query string (added colon support)
  '(\\#[-a-z\\d_]*)?$', // fragment locator
  'i');
  var isValid = !valueToTest ? true : pattern.test(valueToTest);
  return _objectSpread({
    isValid: isValid
  }, !isValid ? {
    message: __('Only valid URLs allowed')
  } : EMPTY_OBJECT);
};
export var isVinValidWithoutIOQ = function isVinValidWithoutIOQ(fieldId, valueToTest) {
  if (_isNil(valueToTest) || _isEmpty(valueToTest)) return {
    isValid: true
  };
  var ioqRegex = /^[^IOQioq]+$/;
  return ioqRegex.test(valueToTest) ? {
    isValid: true
  } : {
    isValid: false,
    message: __('VIN should not contain I, O and Q')
  };
};
export var exactLengthRule = function exactLengthRule(length) {
  return function (fieldId, valueToTest) {
    var valueLength = _size(valueToTest);

    var isValid = valueLength === length;
    return isValid ? {
      isValid: isValid
    } : {
      isValid: isValid,
      message: __('Should contain {{ length }} characters', {
        length: length
      })
    };
  };
};
export var isValidHex = function isValidHex(fiedlId, valueToTest) {
  var pattern = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');
  var isValid = !valueToTest ? true : pattern.test(valueToTest);
  return _objectSpread({
    isValid: isValid
  }, !isValid ? {
    message: __('Should be a valid hex')
  } : EMPTY_OBJECT);
};
export var isPositiveNumber = function isPositiveNumber(fieldId, valueToTest) {
  if (_isNil(valueToTest)) {
    return {
      isValid: true
    };
  }

  var valueInFloat = Number(valueToTest);

  if (_isNaN(valueInFloat) || valueInFloat < 0) {
    return {
      isValid: false,
      message: __('Enter positive number')
    };
  }

  return {
    isValid: true
  };
};
export var isRowRequiredRule = _curry(function (coulumnId, fieldRenderer, valueToTest, formValues) {
  var pathToUpdate = formValues.pathToUpdate;

  var currentRow = _get(formValues, "allValues.".concat(coulumnId, ".").concat(pathToUpdate));

  if (pathToUpdate > 0 && isEmptyRow(currentRow)) {
    return {
      isValid: true
    };
  }

  return isRequiredRule(fieldRenderer, valueToTest, formValues);
});
export var isPhoneNumberFormatRule = function isPhoneNumberFormatRule(fieldId, value) {
  if (_isEmpty(value)) return {
    isValid: true
  };
  var valueToTest = value.phoneNumber;
  if (_isNil(valueToTest) || valueToTest === '(' || valueToTest === '') return {
    isValid: true
  };

  if (valueToTest.length > 16) {
    return {
      isValid: true
    };
  }

  var re = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3} - [0-9]{4}$/;

  if (re.test(valueToTest)) {
    return {
      isValid: true
    };
  }

  return {
    isValid: false,
    message: __('Enter Valid Number')
  };
};
export var isRequiredPhoneRule = function isRequiredPhoneRule(fieldId, valueToTest) {
  var value = valueToTest.phoneNumber;
  var data = getPhoneNo(value);
  if (!data) return {
    isValid: false,
    message: 'This field is Mandatory'
  };
  return {
    isValid: true
  };
};
export var isValidStateCodeRule = function isValidStateCodeRule(addressStates) {
  return function (fieldId, _ref5) {
    var currentValue = _ref5.currentValue;
    return _some(addressStates, function (_ref6) {
      var value = _ref6.value;
      return value === currentValue;
    }) ? {
      isValid: true
    } : {
      isValid: false,
      message: __('Please select a valid state code')
    };
  };
};
/*
 * validates the given date is valid rule for moment fields
 * @returns an object with { isValid, message }
 */

export var isValidDateRule = function isValidDateRule(fieldId, valueToTest) {
  if (valueToTest && !DateUtils.isValidDate(valueToTest)) {
    return {
      isValid: false,
      message: __('Invalid Date')
    };
  }

  return {
    isValid: true
  };
};
export var isTodayOrBeforeTodayRule = function isTodayOrBeforeTodayRule(fieldId, valueToTest) {
  if (valueToTest) {
    var givenDate = DateUtils.toMoment(valueToTest).startOf('day');
    var currentDate = DateUtils.getEndOfToday();
    if (DateUtils.isBefore(currentDate, givenDate, {
      inclusive: true
    })) return {
      isValid: true
    };
    return {
      isValid: false,
      message: __("Shouldn't be future date")
    };
  }

  return {
    isValid: true
  };
};
/**
 * This function help us in identifying if we are validating on child rows or not
 * @param string pathToUpdate for main row it will look like '0' and for child row it would be '0.children.0'
 * @returns
 * Path to update is agnostic to the v7 table, because the pathToUpdate is generated by tableValidator helper
 */

export var isValidatingOnChildRow = function isValidatingOnChildRow(pathToUpdate) {
  var nestingPath = _split(pathToUpdate, '.');

  return _size(nestingPath) > 1;
};
export var isValidRuleName = function isValidRuleName(fieldId, valueToTest) {
  if (_isNil(valueToTest) || !valueToTest) return {
    isValid: true
  };
  var regex = /^[a-zA-Z0-9 {}\/[\]\&\)\(_-]+$/;
  if (valueToTest.match(regex)) return {
    isValid: true
  };
  return {
    isValid: false,
    message: __('Allowed special characters are / ( ) _ - & { } [ ]')
  };
};
export var isValidYearRule = function isValidYearRule() {
  var formatter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity;
  return function (fieldId, valueToTest) {
    var sanitizedValue = formatter(valueToTest);
    if (_isEmpty(sanitizedValue)) return {
      isVald: true
    }; // checks if year lies between 1900 and 2099

    var regex = /^(19|20)\d{2}$/;
    if (regex.test(sanitizedValue)) return {
      isValid: true
    };
    return {
      isValid: false,
      message: __('Enter valid year')
    };
  };
};